import React from 'react'
import { Route } from 'react-router'

const RestorePage = React.lazy(() => import('./restore-page'))
const RestoreDetailPage = React.lazy(() => import('./restore-detail'))

const restoreRoutes = (
  <>
    <Route path='restore' Component={RestorePage} />
    <Route path='restore/:tenantRestoreToken' Component={RestoreDetailPage} />
  </>
)

export default restoreRoutes
